import { Segment } from 'component/Space/Segment'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import { store } from 'store/store'

type Props = {
  value: number,
  plus?: boolean
}

export const Leg = observer(({ value, plus }: Props) => {
  const { form } = store.profile

  const onClick = useLatestCallback(() => {
    form.setLeg(value)
  })

  return <Segment active={form.leg === value} action={onClick}>
    {value}
    {plus && '+'}
  </Segment>
})
